import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './StreamTypeTabLine.styles';

export type StreamFilterTabs =
  | 'all'
  | 'company_catalyst'
  | 'market_catalyst'
  | 'scenarios'
  | 'earnings'
  | 'summaries';

interface StreamTypeTabLineProps {
  selectedTabType: StreamFilterTabs;
  isExplorePage?: boolean;
  onTabChange: (tabType: StreamFilterTabs) => void;
}

export const exploreTabKeys: StreamFilterTabs[] = [
  'all',
  'company_catalyst',
  'market_catalyst',
  'scenarios',
  'earnings',
  'summaries',
];

export type FocusStreamFilterTabs =
  | 'all'
  | 'company_catalyst'
  | 'scenarios'
  | 'earnings';

export const focusTabKeys: FocusStreamFilterTabs[] = [
  'all',
  'company_catalyst',
  'scenarios',
  'earnings',
];

export const StreamTypeTabLine = ({
  selectedTabType,
  isExplorePage = false,
  onTabChange,
}: StreamTypeTabLineProps) => {
  const { t } = useTranslation(['stream']);

  const tabs: Record<StreamFilterTabs, string> = {
    all: t('stream:streamTypeTabs.all'),
    company_catalyst: t('stream:streamTypeTabs.companyCatalysts'),
    market_catalyst: t('stream:streamTypeTabs.marketCatalysts'),
    scenarios: t('stream:streamTypeTabs.scenario'),
    earnings: t('stream:streamTypeTabs.earnings'),
    summaries: t('stream:streamTypeTabs.summaries'),
  };

  const isStreamFilterTab = (key: string) => {
    return (
      key === 'all' ||
      key === 'company_catalyst' ||
      key === 'market_catalyst' ||
      key === 'scenarios' ||
      key === 'earnings' ||
      key === 'summaries'
    );
  };

  const handleChange = (_index: number, tabKey: string) => {
    if (isStreamFilterTab(tabKey)) {
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      onTabChange(tabKey as StreamFilterTabs);
    }
  };

  const tabKeys = isExplorePage ? exploreTabKeys : focusTabKeys;
  return (
    <S.StyledTabLines
      activeTab={selectedTabType}
      onChange={handleChange}
      tabs={tabKeys.map(key => ({
        tabKey: key,
        tabLabel: tabs[key],
      }))}
    />
  );
};
